/**
 * Crew — the teacher / assistants / trainees list in the publish modal.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import type { WorkshopCrewMember } from '../../../../api/workshops';

import { CREW_ROLES, memberName, ROLE_CONFIG } from './crewModel';
import { membersAt } from './publishModalHelpers';

/** Teacher / assistants / trainees, grouped by position, resolved to names. */
export function Crew({ staff }: { staff: WorkshopCrewMember[] }) {
  // BON-466: publishing no longer requires a teacher, so an empty crew is an
  // ordinary state here. Say so rather than collapsing to a blank gap — same
  // reasoning as ScheduleWarning: making the gap legible is not the same as
  // blocking on it.
  if (staff.length === 0) {
    return (
      <p style={{ fontSize: 13, color: 'var(--nb-subtle)', margin: 0 }}>
        No crew assigned yet — you can add crew after publishing.
      </p>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {CREW_ROLES.map((position) => {
        const members = membersAt(staff, position);
        if (members.length === 0) return null;
        const cfg = ROLE_CONFIG[position];
        const label = members.length > 1 ? `${cfg.label}s` : cfg.label;
        return (
          <div key={position} style={{ display: 'flex', gap: 8, fontSize: 13 }}>
            <span style={{ color: 'var(--nb-subtle)', minWidth: 84 }}>{label}</span>
            <span style={{ color: 'var(--nb-ink)' }}>
              {members.map((m) => memberName(m)).join(', ')}
            </span>
          </div>
        );
      })}
    </div>
  );
}

/** The readiness blockers (client mirror + any server 409 fieldErrors). Rendered
 *  only when non-empty; otherwise the modal is clean and Confirm is enabled. */
